import { useContext } from 'react';
import styles from './About.module.css';

import { Modal } from '../modal/Modal';
import { NAVBAR_ICON_URL } from '../../constants';
import config from '../../config';
import { AppContext } from '../../App.context';
import { Icon } from '../icon/Icon';

export const About = ({ show, setShow }: AboutProps) => {
	const { title, version, about } = config.build;
	const handleClick = (e: any) => {
		switch (e.detail) {
			case 2:
				window.location.replace('/drafts');
				break;
		}
	};

	// eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
	const v = <span onClick={handleClick}> {version}</span>;

	return (
		<Modal
			classNames={[styles['container']]}
			hasCloseBtn={true}
			isOpen={show}
			onClose={() => {
				setShow(false);
			}}
		>
			<div className={styles['about-dialog']}>
				<img src={NAVBAR_ICON_URL} alt="icon" />
				<h3>{title}</h3>
				<h4>Version: {v}</h4>
				{about ? (
					<div dangerouslySetInnerHTML={{ __html: about }} />
				) : null}
			</div>
		</Modal>
	);
};

interface AboutProps {
	show: boolean;
	setShow: (value: boolean) => void;
}

export function AboutButton() {
	const { setShowDialog } = useContext(AppContext);
	const className = [styles['about'], 'tooltip down'].join(' ');

	const onClick = () => {
		setShowDialog(true);
	};

	return (
		<button
			type="button"
			className={className}
			data-text="About"
			onClick={onClick}
		>
			<Icon name={'info'} />
		</button>
	);
}
